import { render, staticRenderFns } from "./ProcesoTab.vue?vue&type=template&id=707679ea&"
import script from "./ProcesoTab.vue?vue&type=script&lang=js&"
export * from "./ProcesoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports